import { type FirebaseAllAvailabilitySlot } from "../../firebase/allAvailabilityTypes";
import type { DiscountAvailabilitySlotType } from "../../model/types";
import isSlotAvailable from "../slots/isSlotAvailable";

/** Slot shape used by filter/sort/has helpers (Firebase or derived). */
export type DiscountAvailabilityStrategySlot =
  FirebaseAllAvailabilitySlot | DiscountAvailabilitySlotType;

/**
 * Pluggable slot rules for the shared discount filter/sort/derive pipeline.
 * First Table and walk-in supply different diner fields / include predicates;
 * the pipeline itself stays product-agnostic.
 */
export type DiscountAvailabilityStrategy = {
  /** Distinguishes cache keys when multiple strategies share WeakMaps. */
  modeKey: string;
  /** Extra slot gate after date/session/discount/time filters. */
  includeSlot: (slot: DiscountAvailabilityStrategySlot) => boolean;
  isSlotAvailable: (
    slot: DiscountAvailabilityStrategySlot,
    people?: number | null,
  ) => boolean;
  getDinersAvailable: (
    slot: DiscountAvailabilityStrategySlot,
  ) => number[] | null | undefined;
};

export const firstTableDiscountAvailabilityStrategy: DiscountAvailabilityStrategy =
  {
    modeKey: "ft",
    includeSlot: () => true,
    isSlotAvailable: (slot, people) => isSlotAvailable(slot, people),
    getDinersAvailable: (slot) => slot.dinersAvailable,
  };
